export const debugLog = (...args) => {
    if (window.clientConfig?.debugger) {
        console.log("[DEBUG]", ...args);
    }
};